export { default } from './PhysicianResultView'
export * from './PhysicianResultView'
